import { DownOutlined, DownloadOutlined, LaptopOutlined, LinkOutlined, SettingOutlined } from '@ant-design/icons'
import { Button, Card, Dropdown, Space, Tabs } from 'antd'
import { Content } from 'antd/es/layout/layout'
import Breadcrumbs from 'components/Breadcrumbs'
import IG10_GameStreak from 'components/Infographics/IG10_GameStreak'
import IG11_PointLeaders from 'components/Infographics/IG11_PointLeaders'
import IG12_GoalLeaders from 'components/Infographics/IG12_GoalLeaders'
import IG13_AssistLeaders from 'components/Infographics/IG13_AssistLeaders'
import IG14_StarLeaders from 'components/Infographics/IG14_StarLeaders'
import IG15_PenaltyLeaders from 'components/Infographics/IG15_PenaltyLeaders'
import IG16_Award from 'components/Infographics/IG16_Award'
import IG17_TopPlaysOfSelected from 'components/Infographics/IG17_TopPlaysOfSelected'
import IG18_TopPlaysMostPenalties from 'components/Infographics/IG18_TopPlaysMostPenalties'
import IG19_TopPlaysFewestGoals from 'components/Infographics/IG19_TopPlaysFewestGoals'
import IG1_GamesToday from 'components/Infographics/IG1_GamesToday'
import IG2_DayRecap from 'components/Infographics/IG2_DayRecap'
import IG3_WeekRecap from 'components/Infographics/IG3_WeekRecap'
import IG4_YoutubeThumbnail from 'components/Infographics/IG4_YoutubeThumbnail'
import IG5_StandingsByPoints from 'components/Infographics/IG5_StandingsByPoints'
import IG6_StandingsByPIM from 'components/Infographics/IG6_StandingsByPIM'
import IG7_TeamOffenseVsDefense from 'components/Infographics/IG7_TeamOffenseVsDefense'
import IG8_TeamChancesVsScoring from 'components/Infographics/IG8_TeamChancesVsScoring'
import IG9_TeamFaceOffEfficiency from 'components/Infographics/IG9_TeamFaceOffEfficiency'
import dayjs from 'dayjs'
import usePhaseIdTranslator from 'hooks/usePhaseIdTranslator'
import useSearchParamsMulti from 'hooks/useSearchParamsMulti'
import { domToJpeg, domToPng } from 'modern-screenshot'
import React, { createRef } from 'react'
import useNotificationStore from 'store/notificationStore'
import usePersistentStore from 'store/persistentStore'
import icons from 'utils/icons'
import { generateEmbedUrl } from 'utils/IGParamLogic'

const Infographics = () => {
  const { useSearchParamSingle } = useSearchParamsMulti();
  const [selectedTab, setSelectedTab] = useSearchParamSingle('selectedTab', null);
  const [showData, setShowData] = React.useState(false);
  const [currentMetadata, setCurrentMetadata] = React.useState(null);
  const addMessage = useNotificationStore((state) => state.addMessage);
  
  // Get membership for embed link generation
  const membership = usePersistentStore((state) => state.get('ig-membership'));
  const { phaseIdsAll } = usePhaseIdTranslator(membership);

  const items = [
    {
      key: 'IG1',
      label: '1. Games Today',
      component: IG1_GamesToday,
      exportName: 'GamesToday'
    },
    {
      key: 'IG2',
      label: '2. Day Recap',
      component: IG2_DayRecap,
      exportName: 'DayRecap'
    },
    {
      key: 'IG3',
      label: '3. Week Recap',
      component: IG3_WeekRecap,
      exportName: 'WeekRecap'
    },
    {
      key: 'IG4',
      label: '4. Game YT',
      component: IG4_YoutubeThumbnail,
      exportName: 'GameYT'
    },
    {
      key: 'IG5',
      label: '5. Standings By Points',
      component: IG5_StandingsByPoints,
      exportName: 'StandingsByPoints'
    },
    {
      key: 'IG6',
      label: '6. Standings By PIM',
      component: IG6_StandingsByPIM,
      exportName: 'StandingsByPIM'
    },
    {
      key: 'IG7',
      label: '7. Team Offense Vs Defense',
      component: IG7_TeamOffenseVsDefense,
      exportName: 'TeamOffenseVsDefense'
    },
    {
      key: 'IG8',
      label: '8. Team Chances Vs Scoring',
      component: IG8_TeamChancesVsScoring,
      exportName: 'TeamChancesVsScoring'
    },
    {
      key: 'IG9',
      label: '9. Team Face Off Efficiency',
      component: IG9_TeamFaceOffEfficiency,
      exportName: 'TeamFaceOffEfficiency'
    },
    {
      key: 'IG10',
      label: '10. Game Streak',
      component: IG10_GameStreak,
      exportName: 'GameStreak'
    },
    {
      key: 'IG11',
      label: '11. Point Leaders',
      component: IG11_PointLeaders,
      exportName: 'PointLeaders'
    },
    {
      key: 'IG12',
      label: '12. Goal Leaders',
      component: IG12_GoalLeaders,
      exportName: 'GoalLeaders'
    },
    {
      key: 'IG13',
      label: '13. Assist Leaders',
      component: IG13_AssistLeaders,
      exportName: 'AssistLeaders'
    },
    {
      key: 'IG14',
      label: '14. Star Leaders',
      component: IG14_StarLeaders,
      exportName: 'StarLeaders'
    },
    {
      key: 'IG15',
      label: '15. Penalty Leaders',
      component: IG15_PenaltyLeaders,
      exportName: 'PenaltyLeaders'
    },
    {
      key: 'IG16',
      label: '16. Award',
      component: IG16_Award,
      exportName: 'Award'
    },
    {
      key: 'IG17',
      label: '17. Top Plays Of Selected',
      component: IG17_TopPlaysOfSelected,
      exportName: 'TopPlaysOfSelected'
    },
    {
      key: 'IG18',
      label: '18. Top Plays Most Penalties',
      component: IG18_TopPlaysMostPenalties,
      exportName: 'TopPlaysMostPenalties'
    },
    {
      key: 'IG19',
      label: '19. Top Plays Fewest Goals',
      component: IG19_TopPlaysFewestGoals,
      _exportName: 'TopPlaysFewestGoals'
    }


  ];

  const tabItems = items.map((item) => {
    const ref = createRef();  // generate unique ref for each item - otherwise exporting to PNG could fail
    return {
      key: item.key,
      label: item.label,
      ref,
      children: <>
        <h4>
          {item.label}
        </h4>
        <item.component 
          showData={showData} 
          exportRef={ref} 
          {...(item.key === 'IG2' || item.key === 'IG5' || item.key === 'IG11' || item.key === 'IG12' || item.key === 'IG15' ? { onMetadataChange: setCurrentMetadata } : {})}
        />
      </>,
    };
  });

  const downloadPngClicked = async ({ format }) => {
    const ref = tabItems.find((item) => item.key === selectedTab)?.ref;
    const item = items.find((item) => item.key === selectedTab);
    const domObject = ref?.current;

    if (!domObject) {
      console.error('Failed to take screenshot (no DOM object)');
      return;
    }

    // Get the date from persistent store based on the selected infographic
    const store = usePersistentStore.getState();
    let dateForFilename = dayjs().format('YYYY_MM_DD'); // fallback to current date
    
    if (selectedTab === 'IG1' || selectedTab === 'IG2' || selectedTab === 'IG3') {
      // These infographics use 'ig-date' key (null = today)
      const storedDate = store.get('ig-date');
      if (storedDate != null && storedDate !== '') {
        dateForFilename = dayjs(storedDate, 'YYYY-MM-DD').format('YYYY_MM_DD');
      }
    } 
    else if (selectedTab === 'IG17' || selectedTab === 'IG18' || selectedTab === 'IG19') {
      // These infographics use 'ig-topplays-daterange' key
      const dateRange = store.get('ig-topplays-daterange');
      if (dateRange && Array.isArray(dateRange) && dateRange.length >= 2) {
        const startDate = dayjs(dateRange[0], 'YYYY-MM-DD').format('YYYY_MM_DD');
        const endDate = dayjs(dateRange[1], 'YYYY-MM-DD').format('YYYY_MM_DD');
        dateForFilename = `${startDate}_to_${endDate}`;
      } else if (dateRange && Array.isArray(dateRange) && dateRange.length >= 1) {
        dateForFilename = dayjs(dateRange[0], 'YYYY-MM-DD').format('YYYY_MM_DD');
      }
    }

    const options = {
      scale: 4,
      debug: true
    };
    const JPEG_QUALITY = 0.9;

    function exportDomObject(domObject, format, options) {
      if (format === 'png') {
        return domToPng(domObject, options);
      } else if (format === 'jpeg') {
        return domToJpeg(domObject, {
          ...options,
          quality: JPEG_QUALITY
        });
      }
    }

    exportDomObject(domObject, format, options).then(dataUrl => {
      if (dataUrl?.length < 100) {
        console.error('Failed to take screenshot (too small)');
        return;
      };
      const link = document.createElement('a')
      link.download = `${dateForFilename}_${item.exportName}.${format}`;
      link.href = dataUrl
      link.click()
    })
  }

  // test case for PNG export - might still need it...
  // useInterval(() => {
  //   downloadPngClicked();
  // }, 1000);

  const generateEmbedUrlForCurrentTab = () => {
    const item = items.find(item => item.key === selectedTab);
    if (!item) return null;

    // Get current parameters based on the selected infographic
    let params = {};
    
    if (selectedTab === 'IG2') {
      // Get IG2 specific parameters from persistent store (null date = "Today", omit from embed URL)
      const date = usePersistentStore.getState().get('ig-date');
      const venue = usePersistentStore.getState().get('ig-venue');
      const fgPictureUrl = usePersistentStore.getState().get('ig-dayrecap-fg-url');
      const size = usePersistentStore.getState().get('ig-dayrecap-size');
      const fgImgPositionX = usePersistentStore.getState().get('ig-dayrecap-fgimgposition-x') ?? 0;
      const fgImgPositionY = usePersistentStore.getState().get('ig-dayrecap-fgimgposition-y') ?? 0;
      const fgImgZoom = usePersistentStore.getState().get('ig-dayrecap-fgzoom') ?? 450;
      const fgImgMargin = usePersistentStore.getState().get('ig-dayrecap-margin') ?? { top: 0, left: 0, bottom: 0, right: 0 };
      const backgroundMode = usePersistentStore.getState().get('ig-dayrecap-background-mode');
      const backgroundImgUrl = usePersistentStore.getState().get('ig-dayrecap-background-img-url');
      const backgroundColor = usePersistentStore.getState().get('ig-dayrecap-background-img-color');
      
      const venueIdsAll = venue?.venueIds == null || venue?.venueIds.length === 0 ? undefined : venue?.venueIds;
      
      params = {
        seasonId: membership?.seasonId,
        date,
        phaseIdsAll,
        venueIdsAll,
        fgPictureUrl,
        fgImgPositionX,
        fgImgPositionY,
        fgImgZoom,
        size,
        fgImgMargin,
        backgroundMode: backgroundMode ?? (backgroundImgUrl ? 'IMAGE' : backgroundColor ? 'COLOR' : 'DEFAULT'),
        backgroundImgUrl,
        backgroundColor,
        metadata: currentMetadata, // Use the exact metadata from the component
        enablePositioning: false // Disable positioning for embed
      };
    } else if (selectedTab === 'IG5') {
      // Get IG5 specific parameters from persistent store
      const fgPictureUrl = usePersistentStore.getState().get('ig-standings-fg-url');
      const size = usePersistentStore.getState().get('ig-standings-size');
      const fgImgPositionX = usePersistentStore.getState().get('ig-standings-fgimgposition-x') ?? 0;
      const fgImgPositionY = usePersistentStore.getState().get('ig-standings-fgimgposition-y') ?? 0;
      const fgImgZoom = usePersistentStore.getState().get('ig-standings-fgzoom') ?? 100;
      const fgImgMargin = usePersistentStore.getState().get('ig-standings-margin') ?? { top: 0, left: 0, bottom: 0, right: 0 };
      const isRolling = usePersistentStore.getState().get('ig-standings-rolling') ?? false;
      const rollingRowsPerPage = usePersistentStore.getState().get('ig-standings-rolling-rows-per-page') ?? 10;
      const rollingIntervalSeconds = usePersistentStore.getState().get('ig-standings-rolling-interval') ?? 5;
      const backgroundMode = usePersistentStore.getState().get('ig-standings-background-mode');
      const backgroundImgUrl = usePersistentStore.getState().get('ig-standings-background-img-url');
      const backgroundColor = usePersistentStore.getState().get('ig-standings-background-img-color');
      
      params = {
        phaseIdsAll,
        fgPictureUrl,
        fgImgPositionX,
        fgImgPositionY,
        fgImgZoom,
        size,
        fgImgMargin,
        backgroundMode: backgroundMode ?? (backgroundImgUrl ? 'IMAGE' : backgroundColor ? 'COLOR' : 'DEFAULT'),
        backgroundImgUrl,
        backgroundColor,
        isRolling,
        rollingRowsPerPage,
        rollingIntervalSeconds,
        metadata: currentMetadata, // Use the exact metadata from the component
        enablePositioning: false // Disable positioning for embed
      };
    } else if (selectedTab === 'IG11') {
      // Get IG11 specific parameters from persistent store
      const fgPictureUrl = usePersistentStore.getState().get('ig-pointleaders-fg-url');
      const size = usePersistentStore.getState().get('ig-pointleaders-size');
      const fgImgPositionX = usePersistentStore.getState().get('ig-pointleaders-fgimgposition-x') ?? 0;
      const fgImgPositionY = usePersistentStore.getState().get('ig-pointleaders-fgimgposition-y') ?? 0;
      const fgImgZoom = usePersistentStore.getState().get('ig-pointleaders-fgzoom') ?? 100;
      const fgImgMargin = usePersistentStore.getState().get('ig-pointleaders-margin') ?? { top: 0, left: 0, bottom: 0, right: 0 };
      const selectedTeams = usePersistentStore.getState().get('ig-pointleaders-selected-teams') ?? [];
      const topCount = usePersistentStore.getState().get('ig-pointleaders-top-count');
      const backgroundMode = usePersistentStore.getState().get('ig-pointleaders-background-mode');
      const backgroundImgUrl = usePersistentStore.getState().get('ig-pointleaders-background-img-url');
      const backgroundColor = usePersistentStore.getState().get('ig-pointleaders-background-img-color');
      
      params = {
        phaseIdsAll,
        fgPictureUrl,
        fgImgPositionX,
        fgImgPositionY,
        fgImgZoom,
        size,
        fgImgMargin,
        backgroundMode: backgroundMode ?? (backgroundImgUrl ? 'IMAGE' : backgroundColor ? 'COLOR' : 'DEFAULT'),
        backgroundImgUrl,
        backgroundColor,
        selectedTeams,
        topCount,
        metadata: currentMetadata, // Use the exact metadata from the component
        enablePositioning: false // Disable positioning for embed
      };
    } else if (selectedTab === 'IG12') {
      // Get IG12 specific parameters from persistent store
      const fgPictureUrl = usePersistentStore.getState().get('ig-goalleaders-fg-url');
      const size = usePersistentStore.getState().get('ig-goalleaders-size');
      const fgImgPositionX = usePersistentStore.getState().get('ig-goalleaders-fgimgposition-x') ?? 0;
      const fgImgPositionY = usePersistentStore.getState().get('ig-goalleaders-fgimgposition-y') ?? 0;
      const fgImgZoom = usePersistentStore.getState().get('ig-goalleaders-fgzoom') ?? 100;
      const fgImgMargin = usePersistentStore.getState().get('ig-goalleaders-margin') ?? { top: 0, left: 0, bottom: 0, right: 0 };
      const selectedTeams = usePersistentStore.getState().get('ig-goalleaders-selected-teams') ?? [];
      const backgroundMode = usePersistentStore.getState().get('ig-goalleaders-background-mode');
      const backgroundImgUrl = usePersistentStore.getState().get('ig-goalleaders-background-img-url');
      const backgroundColor = usePersistentStore.getState().get('ig-goalleaders-background-img-color');
      
      params = {
        phaseIdsAll,
        fgPictureUrl,
        fgImgPositionX,
        fgImgPositionY,
        fgImgZoom,
        size,
        fgImgMargin,
        backgroundMode: backgroundMode ?? (backgroundImgUrl ? 'IMAGE' : backgroundColor ? 'COLOR' : 'DEFAULT'),
        backgroundImgUrl,
        backgroundColor,
        selectedTeams,
        metadata: currentMetadata, // Use the exact metadata from the component
        enablePositioning: false // Disable positioning for embed
      };
    } else if (selectedTab === 'IG15') {
      // Get IG15 specific parameters from persistent store
      const fgPictureUrl = usePersistentStore.getState().get('ig-penaltyleaders-fg-url');
      const size = usePersistentStore.getState().get('ig-penaltyleaders-size');
      const fgImgPositionX = usePersistentStore.getState().get('ig-penaltyleaders-fgimgposition-x') ?? 0;
      const fgImgPositionY = usePersistentStore.getState().get('ig-penaltyleaders-fgimgposition-y') ?? 0;
      const fgImgZoom = usePersistentStore.getState().get('ig-penaltyleaders-fgzoom') ?? 100;
      const fgImgMargin = usePersistentStore.getState().get('ig-penaltyleaders-margin') ?? { top: 0, left: 0, bottom: 0, right: 0 };
      const selectedTeams = usePersistentStore.getState().get('ig-penaltyleaders-selected-teams') ?? [];
      const backgroundMode = usePersistentStore.getState().get('ig-penaltyleaders-background-mode');
      const backgroundImgUrl = usePersistentStore.getState().get('ig-penaltyleaders-background-img-url');
      const backgroundColor = usePersistentStore.getState().get('ig-penaltyleaders-background-img-color');
      
      params = {
        phaseIdsAll,
        fgPictureUrl,
        fgImgPositionX,
        fgImgPositionY,
        fgImgZoom,
        size,
        fgImgMargin,
        backgroundMode: backgroundMode ?? (backgroundImgUrl ? 'IMAGE' : backgroundColor ? 'COLOR' : 'DEFAULT'),
        backgroundImgUrl,
        backgroundColor,
        selectedTeams,
        metadata: currentMetadata, // Use the exact metadata from the component
        enablePositioning: false // Disable positioning for embed
      };
    }
    
    try {
      return generateEmbedUrl(selectedTab, params);
    } catch (error) {
      console.error('Failed to generate embed URL:', error);
      return null;
    }
  };

  const generateEmbedLinkClicked = (event) => {
    const embedUrl = generateEmbedUrlForCurrentTab();
    if (!embedUrl) {
      alert('Failed to generate embed link. Please check your parameters.');
      return;
    }
    
    // Check if Ctrl (Windows/Linux) or Cmd (Mac) key is pressed
    const isModifierPressed = event.ctrlKey || event.metaKey;
    
    // Copy to clipboard
    navigator.clipboard.writeText(embedUrl).then(() => {
      // You could add a toast notification here
      // alert('Embed link copied to clipboard!');
      addMessage({ text: 'Embed link copied to clipboard', type: 'success' });

      // If modifier key is pressed, also open the URL in a new tab
      if (isModifierPressed) {
        // Ctrl/Cmd+click: Open embed page directly
        window.open(embedUrl, '_blank', 'noopener,noreferrer');
      }

    }).catch(err => {
      console.error('Failed to copy to clipboard:', err);
      // Fallback: show the URL in a prompt
      prompt('Copy this embed link:', embedUrl);
      
      // If modifier key is pressed, also open the URL in a new tab
      if (isModifierPressed) {
        // Ctrl/Cmd+click: Open embed page directly
        window.open(embedUrl, '_blank', 'noopener,noreferrer');
      }
    });
  };

  const openEmbedTestPageClicked = () => {
    const embedUrl = generateEmbedUrlForCurrentTab();
    if (!embedUrl) {
      alert('Failed to generate embed test link. Please check your parameters.');
      return;
    }
    
    // Open test page (replace /embed/ig with /embed/ig-test)
    const testUrl = embedUrl.replace('/embed/ig', '/embed/ig-test');
    window.open(testUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Content className="m-3 desktop:m-4 desktop:mr-0">
      <Breadcrumbs items={[{ title: 'Infographics', icon: icons.Infographics }]} />
      <div className="flex gap-5 items-start">
        <Card
          title={
            <div className="flex justify-between items-center">

              <span className="flex gap-4 items-center">
                Infographics generator
              </span>

              <span className="flex items-center gap-2">

                {selectedTab === 'IG4' && (
                  <Button
                    size="small"
                    className="bg-red-500 border-red-500 text-white hover:!text-white hover:!border-red-500"
                    icon={<DownloadOutlined />}
                    onClick={() => downloadPngClicked({ format: 'jpeg' })}
                  >
                    Download JPEG for YouTube
                  </Button>
                )}

                {(selectedTab === 'IG2' || selectedTab === 'IG5' || selectedTab === 'IG11' || selectedTab === 'IG12' || selectedTab === 'IG15') && (
                  <>
                    <Button
                      size="small"
                      icon={<LinkOutlined />}
                      onClick={(event) => generateEmbedLinkClicked(event)}
                    >
                      Get Embed Url
                    </Button>
                    <Button
                      size="small"
                      icon={< LaptopOutlined/>}
                      onClick={openEmbedTestPageClicked}
                    >
                      Embed Configurator
                    </Button>
                  </>
                )}

                <Button
                  type="primary"
                  size="small"
                  icon={<DownloadOutlined />}
                  onClick={() => downloadPngClicked({ format: 'png' })}
                >
                  Download PNG
                </Button>


                <Dropdown
                  placement="bottomRight"
                  menu={{
                    items: [{
                      label: 'Show data',
                      onClick: () => setShowData(!showData),
                    }]
                  }}>
                  <Button size="small">
                    <Space>
                      <SettingOutlined />
                      System
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </span>
            </div>

          }
          className="w-full max-w-[calc(100vw-25px)] desktop:max-w-[calc(100vw-233px)]"
          size="small"
        >
          <div className="overflow-scroll">
            <Tabs defaultActiveKey="1"
              activeKey={selectedTab}
              // renderTabBar={(props, DefaultTabBar) => (
              //   // <DefaultTabBar {...props} className="h-[100vh]"/>
              //   <DefaultTabBar {...props} className="h-[400px]"/>
              // )}
              destroyInactiveTabPane={true}
              onChange={(ak) => setSelectedTab(ak)}
              items={tabItems}
              tabPosition='left' />
          </div>
        </Card>
      </div>
    </Content>
  )
}

export default Infographics
